module.exports = __webpack_public_path__ + "img/bd_logo_black.85f9a27a.png";